import { render, staticRenderFns } from "./ClientSearchDialog.vue?vue&type=template&id=63051fc9&scoped=true&"
import script from "./ClientSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ClientSearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchDialog.vue?vue&type=style&index=0&id=63051fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63051fc9",
  null
  
)

export default component.exports